<template>
  <div class="gamelist">
    <div class="emptyData" v-if="fansList.length <= 0">
      {{ $t("common.emptyData") }}
    </div>
    <ul v-if="fansList.length > 0">
      <li v-for="(item, index) in fansList" :key="index">
        <a target="_blank" :href="item.url">
          <div class="gamelist-title">
            <!-- <img :src="item.game_icon" alt="" /> -->
            <!-- <img src="//img.komoejoy-sea.com/image/202105/78b97857f5023392305a0973ae4462f0.jpg" alt=""> -->
            <p>{{ item.group_name }}</p>
          </div>
          <div class="gamelist-img">
            <img src="@/assets/images/h5/icon5.png" alt="" />
          </div>
        </a>
      </li>
    </ul>
    <h5-nav :pageName="pageInfo" v-if="$region !== 'jp' "></h5-nav>
  </div>
</template>
<script>
import h5Nav from "@/component/h5nav/komoe";
export default {
  name: "fansH5",
  data() {
    return {
      fansList: [],
      pageInfo: "",
    };
  },
  components: {
    h5Nav,
  },
  created() {
    this.pageInfo = this.$route.name;
    this.getFansList();
  },
  mounted() {},
  methods: {
    getFansList() {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.$apis.header.getFansList().then((res) => {
        this.$toast.clear();
        if (res.data.code == 0) {
          res.data.data.forEach((i) => {
            this.fansList.push(i);
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.gamelist {
  width: 100%;
  position: relative;
  margin-top: 0.48rem;
  min-height: calc(100vh - 2.75rem);
  height: auto;
  .emptyData {
    padding-top: 0.5rem;
    color: #b5b5b5;
    font-size: 0.16rem;
    text-align: center;
  }
  li {
    width: 92%;
    height: 0.55rem;
    margin: auto;
    margin-bottom: 0.15rem;
    background: #fbfbfb;
    &:nth-last-of-type(1) {
      margin-bottom: 0.1rem !important;
    }
    a {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .gamelist-title {
        width: auto;
        height: 100%;
        margin-left: 0.05rem;
        display: flex;
        align-items: center;
        img {
          display: flex;
          width: 0.44rem;
          height: 0.44rem;
          border-radius: 0.04rem;
          object-fit: cover;
        }
        p {
          margin-left: 0.13rem;
          font-size: 0.13rem;
          font-family: SourceHanSansCN;
          font-weight: bold;
          color: #444444;
        }
      }
      .gamelist-img {
        width: 0.15rem;
        height: 0.15rem;
        margin-right: 0.05rem;
        background: #50bbe5;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
